import { jsx as _jsx } from "react/jsx-runtime";
import { useGenerateScriptPanelContext } from '@/hoc';
import { ScriptConfigurationPanel, ThemeConfigurationPanel } from './theme-config';
export var JdGenerateScriptPanel = function () {
    var _a = useGenerateScriptPanelContext(), configuration = _a.configuration, isThemePanelOpen = _a.isThemePanelOpen, setConfiguration = _a.setConfiguration, setTheme = _a.setTheme, theme = _a.theme;
    if (isThemePanelOpen) {
        return (_jsx(ThemeConfigurationPanel, { theme: theme, setTheme: setTheme, configuration: configuration, setConfiguration: setConfiguration }));
    }
    return (_jsx(ScriptConfigurationPanel, { configuration: configuration, setConfiguration: setConfiguration }));
};
